module.exports = __webpack_public_path__ + "static/media/intro_icon_1.4899de2e.svg";